"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const getLocaleFromPreferences = data => {
  if (data && data.preferences) {
    const {
      userLanguage
    } = data.preferences;
    const langPart = userLanguage.split('-')[0];
    if (langPart === 'zh') return 'zh';
    return 'en';
  }
  return 'en';
};
var _default = exports.default = getLocaleFromPreferences;